<fc-search-many-input
  [label]="'LOCATION_GROUPS.LABEL' | translate"
  [control]="control"
  [search]="search"
  [displayWith]="displayWith"
></fc-search-many-input>
